<template>
  <section>
    <div class="containerst">
      <div style="display: flex; margin-top: 10px">
        <div class="zhuti">
          <!-- <el-button type="primary" style="display: block" @click="addSubtotal"
            >添加分类</el-button
          > -->

          <div class="group_simpleBox">
            <TreeSelect
                style="margin-bottom: 10px"
                :placeholderOne="'部门'"
                :typeids="listQuery.deptId"
                :width="150"
                :parentIdOne="parentIdOne"
                @popoverHide="AddDept"
                @clearDept="clearDept"
            ></TreeSelect>
            <div class="group_simple">

              <div
                class="diff_div layout"
                v-for="(item, index) in questDatalists"
                :key="index"
              >
                <div class="tree">
                  <TreeTestChoice
                    :lianxi="true"
                    :checkedData="item.checkIds"
                    :deptId="listQuery.deptId"
                    @btnKey="btnKeyTwo($event, index)"
                  ></TreeTestChoice>
                </div>
                <div>

                  <div class="row">
                    <div>单选题</div>
                    <div class="group_titleul_ligs">
                      <el-input
                        type="number"
                        min="0"
                        v-model.number="item.cnt1"
                        v-on:input="
                          inputChangeNumjd($event, index, item.sum1, 1)
                        "
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        :disabled="item.sum1 == 0 ? true : false"
                      ></el-input>
                      <!-- v-on:input="inputChangeNumjd($event,index,item.sum1,1)" -->
                      <div style="padding-left: 5px">/ {{ item.sum1 }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div>多选题</div>
                    <div class="group_titleul_ligs">
                      <el-input
                        type="number"
                        min="0"
                        v-model.number="item.cnt2"
                        v-on:input="
                          inputChangeNumjd($event, index, item.sum2, 2)
                        "
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        :disabled="item.sum2 == 0 ? true : false"
                      ></el-input>
                      <div style="padding-left: 5px">/ {{ item.sum2 }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div>判断题</div>
                    <div class="group_titleul_ligs">
                      <el-input
                        type="number"
                        min="0"
                        v-model.number="item.cnt3"
                        v-on:input="
                          inputChangeNumjd($event, index, item.sum3, 3)
                        "
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        :disabled="item.sum3 == 0 ? true : false"
                      ></el-input>
                      <div style="padding-left: 5px">/ {{ item.sum3 }}</div>
                    </div>
                  </div>
                  <!-- <div style="width: 100px; text-align: center">
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleSubtotal(index)"
                      style="margin: 0 auto"
                      >删除</el-button
                    >
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import eleSelect from "@/components/elSelect"; //下拉框
import TreeSelect from "@/components/treeSelectt";
import elDragDialog from "@/directive/el-dragDialog";

import * as dictionarys from "@/api/pmi/dictionarys";
import {
  AddPaperQuestion,
  SelectDetailsPaper,
  GetAutoQuestionList,
} from "@/api/exam/manualpaper";
import TreeTestChoice from "./treeTestChoice";
import { SelectAutoPaper } from "@/api/exam/autopaper";

export default {
  components: {
    eleSelect,
    TreeSelect,
    TreeTestChoice,
  },
  directives: {
    elDragDialog,
  },
  props: ["EditIds", "examTitle", "examId"],
  data() {
    return {
      // defaultCheckedKeys: [{"label":"新疆省厅","id":302,"leaf":false,"nameReal":"新疆省厅"}],
      resultLbael: [],
      listQuery: {
        label: "",
        deptId: JSON.parse(this.$store.state.User.infos).unitId,
      },
      parentIdOne: JSON.parse(this.$store.state.User.infos).unitId,
      EditId: this.$route.query.id,
      zddata: 1,
      objList: {},
      checkedData: [],
      previewDialogVisible: false,
      sumScoreAll: 0,
      TotalAllleft: 0,
      // questDatalists: [],
      titleinput: this.examTitle,
      subjectId: 0,
      cxsubjectId: 0,
      cateId: 0,
      value4: "",
      value5: null,
      form: {},
      radio1: 0,
      radio2: 1,
      name: null,
      CheckedKeys: [],
      res: [],
      paperId: 0,
      //树的默认数据
      temp: { parentId: "", parentName: "" },

      dialogStatus: "update",
      sid: +new Date(),
      status: false,
      cateIdisShow: false,

      visible: false,

      cateTitle: "请选择试题分类",
      cateTitleTwo: "请选择试题分类",
      cateIds: "",

      radioTopicTotal: 0,
      radioScoreTotal: 0,

      checkTopicTotal: 0,
      checkScoreTotal: 0,

      judgeTopicTotal: 0,
      judgeScoreTotal: 0,

      gapFillingTopicTotal: 0,
      gapFillingScoreTotal: 0,

      essayTopicTotal: 0,
      essayScoreTotal: 0,
      scoreRuleObj: {
        radioScoreTotalItem: 1,
        checkScoreTotalItem: 1,
        judgeScoreTotalItem: 1,
        essayScoreTotalItem: 0,
        gapFillingScoreTotalItem: 0,
      },

      resultSum: {},
      questDatalists: [
        {
          cateIds: "",
          cateName: "请选择试题分类",

          cnt1: 0,
          cnt2: 0,
          cnt3: 0,
          cnt4: 0,
          cnt5: 0,

          label: [],
          sum1: 0,
          sum2: 0,
          sum3: 0,
          sum4: 0,
          sum5: 0,
        },
      ],
      reuslts: {
        cateIds: "",
        cateName: "请选择试题分类",

        cnt1: 0,
        cnt2: 0,
        cnt3: 0,
        cnt4: 0,
        cnt5: 0,

        label: [],
        sum1: 0,
        sum2: 0,
        sum3: 0,
        sum4: 0,
        sum5: 0,
      },
      popoverIndex: -99,
      typeOne: 0, //传0过去只显示部门，不穿显示所有部门
      // parentIdOne: JSON.parse(this.$store.state.User.info).deptId,
    };
  },
  methods: {
    //部门
    AddDept(checkedIds, checkedData) {
      console.log(1111111111111111111)
      this.listQuery.deptId = checkedData.id;
      this.clearData();
    },
    clearDept() {
      this.listQuery.deptId = null;
      this.clearData();
    },
    // 获取题目标签
    getPmiDicLabel() {
      let data = { namespaceId: 47 };
      dictionarys.getByTypeId(data).then((res) => {
        this.resultLbael = res.result;
      });
    },
    // 根据状态查询
    queryAllState(val, index, cateIds) {
      if (val && cateIds) {
        // this.listQuery.label = val.join(',');
        this.listQuery.label = val;
        this.ApaperList(index, 1);
      }
    },
    // 分类题型选分值
    inputChangeNumjd(value, index, sum, type) {
      // console.log(value, index, sum, type);
      let integer = /^(-|\+)?\d+$/; //输入整数(包括0)的正则，解决不能输入负号问题
      if (integer.test(value)) {
        if (Number(value) > Number(sum)) {
          if (type == 1) {
            this.questDatalists[index].cnt1 = 0;
          } else if (type == 2) {
            this.questDatalists[index].cnt2 = 0;
          } else if (type == 3) {
            this.questDatalists[index].cnt3 = 0;
          } else if (type == 4) {
            this.questDatalists[index].cnt4 = 0;
          } else if (type == 5) {
            this.questDatalists[index].cnt5 = 0;
          }
        }
      }
      // 分类题型的总提和总分
      this.getNumli();
    },
    // 删除分类分值
    deleSubtotal(index) {
      this.questDatalists.splice(index, 1);
      localStorage.setItem(
        "questDatalists",
        JSON.stringify(this.questDatalists)
      );
      if (this.questDatalists.length != 0) {
        this.getNumli();
      }
    },
    // 添加分类
    addSubtotal() {
      this.initialized();
      this.questDatalists.push(this.reuslts);
      localStorage.setItem(
        "questDatalists",
        JSON.stringify(this.questDatalists)
      );
    },
    // 初始化数据
    initialized() {
      this.reuslts = {
        cateIds: "",
        cateName: "请选择试题分类",

        cnt1: 0,
        cnt2: 0,
        cnt3: 0,
        cnt4: 0,
        cnt5: 0,

        label: [],
        sum1: 0,
        sum2: 0,
        sum3: 0,
        sum4: 0,
        sum5: 0,
      };
    },

    // 添加试题
    createquestData() {
      if (Number(this.resultSum.sum1) < Number(this.resultSum.cnt1)) {
        this.$message({
          message: "输入的简单题型不能大于简单题型总数",
          type: "warning",
        });
        return false;
      }
      if (Number(this.resultSum.sum2) < Number(this.resultSum.cnt2)) {
        this.$message({
          message: "输入的普通题型不能大于普通题型总数",
          type: "warning",
        });
        return false;
      }
      if (Number(this.resultSum.sum1) < Number(this.resultSum.cnt1)) {
        this.$message({
          message: "输入的困难题型不能大于困难题型总数",
          type: "warning",
        });
        return false;
      }
    },

    // 选中试题分类
    btnKeyTwo(data, index) {
      console.log(data)
      if (data.length != 0) {
        let cateIdList = [];
        let cateNameList = [];
        data.forEach((item) => {
          cateIdList.push(item.id);
          cateNameList.push(item.label);
        });
        this.cateIds = cateIdList.join(",");
        this.cateTitleTwo = cateNameList.join(",");

        this.ApaperList(index);
      } else {
        this.initialized(); //清空数组
        this.cateIds = "";
        this.cateTitleTwo = "请选择分类";
        this.questDatalists.splice(index, 1, this.reuslts);
      }
      document.body.click(); //模拟点击事件关闭弹窗
    },
    clearData() {
      this.initialized(); //清空数组
      this.cateIds = "";
      this.cateTitleTwo = "请选择分类";
      this.questDatalists.splice(0, 1, this.reuslts);
    },
    // 根据试题分类查询难易度
    ApaperList(index, labelId) {
      let label = "";
      if (this.questDatalists.length != 0) {
        if (this.questDatalists[index].label.length != 0) {
          label = this.questDatalists[index].label;
        }
      }

      let para = {
        cateIds: this.cateIds,
        deptId: this.listQuery.deptId,
        label: label,
      };

      if (labelId == 1) {
        para.cateIds = this.questDatalists[index].cateIds;
      }

      SelectAutoPaper(para).then((res) => {
        // console.log(res.result);
        let list = res.result;
        let label = "";
        if (list.label) {
          label = list.label.split(",");
          list.label = label;
        } else {
          list.label = [];
        }

        if (labelId == 1) {
          list.cateName = this.questDatalists[index].cateName;
        } else {
          list.cateName = this.cateTitleTwo; //赋值分类名称
        }
        this.questDatalists.splice(index, 1, list);
        this.getNumli();
        localStorage.setItem(
          "questDatalists",
          JSON.stringify(this.questDatalists)
        );
      });
    },

    // 创建每题分数
    inputChange() {
      this.getNumli();
    },

    // 计算一个分类的总提和总分
    getNumli() {
      this.radioScoreTotal = 0;
      this.checkScoreTotal = 0;
      this.judgeScoreTotal = 0;
      this.gapFillingScoreTotal = 0;
      this.essayScoreTotal = 0;

      this.TotalAllleft = 0;
      this.sumScoreAll = 0;

      this.radioTopicTotal = 0;
      this.checkTopicTotal = 0;
      this.judgeTopicTotal = 0;
      this.gapFillingTopicTotal = 0;
      this.essayTopicTotal = 0;

      for (let i = 0; i < this.questDatalists.length; i++) {
        this.radioTopicTotal += Number(this.questDatalists[i].cnt1);
        this.checkTopicTotal += Number(this.questDatalists[i].cnt2);
        this.judgeTopicTotal += Number(this.questDatalists[i].cnt3);
        this.gapFillingTopicTotal += Number(this.questDatalists[i].cnt4);
        this.essayTopicTotal += Number(this.questDatalists[i].cnt5);
      }

      this.radioScoreTotal =
        Number(this.radioTopicTotal) * this.scoreRuleObj.radioScoreTotalItem;

      this.checkScoreTotal =
        Number(this.checkTopicTotal) * this.scoreRuleObj.checkScoreTotalItem;
      this.judgeScoreTotal =
        Number(this.judgeTopicTotal) * this.scoreRuleObj.judgeScoreTotalItem;
      this.gapFillingScoreTotal =
        Number(this.gapFillingTopicTotal) *
        this.scoreRuleObj.gapFillingScoreTotalItem;
      this.essayScoreTotal =
        Number(this.essayTopicTotal) * this.scoreRuleObj.essayScoreTotalItem;

      this.sumScoreAll =
        this.radioScoreTotal +
        this.checkScoreTotal +
        this.judgeScoreTotal +
        this.gapFillingScoreTotal +
        this.essayScoreTotal;

      this.sumScoreAll = Math.floor(Number(this.sumScoreAll) * 100) / 100;

      this.TotalAllleft =
        this.radioTopicTotal +
        this.checkTopicTotal +
        this.judgeTopicTotal +
        this.gapFillingTopicTotal +
        this.essayTopicTotal;

      // 存储每题分数
      localStorage.setItem("scoreRuleObj", JSON.stringify(this.scoreRuleObj));
      localStorage.setItem(
        "questDatalists",
        JSON.stringify(this.questDatalists)
      );
    },

    // 初始化下拉分类类型
    openPopover(popoverIndex) {
      this.popoverIndex = popoverIndex;
      this.$refs["popover-" + popoverIndex].doShow;
    },

    // 预览试题
    previewtestquestions() {
      if (this.TotalAllleft == 0) {
        this.$message({
          message: "题目数量不能为空",
          type: "warning",
        });
      } else if (this.sumScoreAll == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else {
        let questDatalists = this.questDatalists;
        for (let i = 0; i < questDatalists.length; i++) {
          if (questDatalists[i].label) {
            questDatalists[i].label = questDatalists[i].label.toString();
          }
        }

        let objList = {
          deptId: JSON.parse(this.$store.state.User.infos).deptId,
          autoCount: questDatalists,
          scoreRule: {
            score1: this.scoreRuleObj.radioScoreTotalItem,
            score2: this.scoreRuleObj.checkScoreTotalItem,
            score3: this.scoreRuleObj.judgeScoreTotalItem,
            score4: this.scoreRuleObj.gapFillingScoreTotalItem,
            score5: this.scoreRuleObj.essayScoreTotalItem,
          },
        };
        this.objList = objList;
        this.previewDialogVisible = true;
      }
    },
    //确认添加
    startExam() {
      let paperId = 0;
      let questDatalists = this.questDatalists;
      for (let i = 0; i < questDatalists.length; i++) {
        if (questDatalists[i].label) {
          questDatalists[i].label = questDatalists[i].label.toString();
        }
      }

      let objList = {
        autoCount: questDatalists,
        deptId: this.listQuery.deptId,
        scoreRule: {
          score1: this.scoreRuleObj.radioScoreTotalItem,
          score2: this.scoreRuleObj.checkScoreTotalItem,
          score3: this.scoreRuleObj.judgeScoreTotalItem,
          score4: this.scoreRuleObj.gapFillingScoreTotalItem,
          score5: this.scoreRuleObj.essayScoreTotalItem,
        },
      };

      // let para = {
      //   title: this.titleinput,
      //   totalScore: this.sumScoreAll,
      //   subjectId: this.subjectId,
      //   cateId: this.cateId,
      //   type: this.radio1,
      //   level: this.radio2,
      //   createType: 2,
      //   status: 1,
      //   deptId: this.temp.pagerId,
      //   deptName: this.temp.parentName,
      //   isDel: 0,
      //   createId: this.$store.state.User.id,
      //   createName:JSON.parse(this.$store.state.User.info).name,
      //   count: this.TotalAllleft,
      //   rules: JSON.stringify(objList),
      // };

      if (this.TotalAllleft == 0) {
        this.$message({
          message: "题目数量不能为空",
          type: "warning",
        });
      } else if (this.radioTopicTotal != 0 && this.radioScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (this.checkTopicTotal != 0 && this.checkScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (this.judgeTopicTotal != 0 && this.judgeScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (
        this.gapFillingTopicTotal != 0 &&
        this.gapFillingScoreTotal == 0
      ) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (this.essayTopicTotal != 0 && this.essayScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else {
        // 用规则查询试题
        GetAutoQuestionList(objList).then((res3) => {
          let list = res3.result;
          this.$emit("getPaper", list);
          this.$emit("close");
          console.log("list", list);
          sessionStorage.setItem("tempExam", JSON.stringify(list));

          this.$router.push({
            path: "/BrushTopic2",
          });

          // let question = list.map((a) => {
          //   return {
          //     examId: this.examId,
          //     questionId: a.id,
          //     sort: 0,
          //     score: a.score,
          //   };
          // });
          // // 添加试卷;
          // AddPaperQuestion(question).then((res2) => {
          //   if (res3.code == 200) {
          //     this.$emit('close');
          //   } else {
          //     this.$message.error('添加失败');
          //   }
          // });
        });
      }
    },

    // 修改自动 UpdatePaper
    updateDatas() {
      let paperId = 0;
      let questDatalists = this.questDatalists;
      for (let i = 0; i < questDatalists.length; i++) {
        if (questDatalists[i].label) {
          questDatalists[i].label = questDatalists[i].label.toString();
        }
      }
      let objList = {
        autoCount: this.questDatalists,
        deptId: JSON.parse(this.$store.state.User.infos).deptId,
        scoreRule: {
          score1: this.scoreRuleObj.radioScoreTotalItem,
          score2: this.scoreRuleObj.checkScoreTotalItem,
          score3: this.scoreRuleObj.judgeScoreTotalItem,
          score4: this.scoreRuleObj.gapFillingScoreTotalItem,
          score5: this.scoreRuleObj.essayScoreTotalItem,
        },
      };
      // let para = {
      //   id: this.EditId,
      //   title: this.titleinput,
      //   totalScore: this.sumScoreAll,
      //   subjectId: this.subjectId,
      //   cateId: this.cateId,
      //   type: this.radio1,
      //   level: this.radio2,
      //   createType: 2,
      //   status: 1,
      //   deptId: this.temp.pagerId,
      //   deptName: this.temp.parentName,
      //   isDel: 0,
      //   createId: this.$store.state.User.id,
      //   count: this.TotalAllleft,
      //   rules: JSON.stringify(objList),
      // };

      if (this.TotalAllleft == 0) {
        this.$message({
          message: "题目数量不能为空",
          type: "warning",
        });
      } else if (this.radioTopicTotal != 0 && this.radioScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (this.checkTopicTotal != 0 && this.checkScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (this.judgeTopicTotal != 0 && this.judgeScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (
        this.gapFillingTopicTotal != 0 &&
        this.gapFillingScoreTotal == 0
      ) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else if (this.essayTopicTotal != 0 && this.essayScoreTotal == 0) {
        this.$message({
          message: "请输入题目分数",
          type: "warning",
        });
      } else {
        // 用规则查询试题
        GetAutoQuestionList(objList).then((res3) => {
          let list = res3.result;
          let question = list.map((a) => {
            return {
              paperId: this.EditId,
              questionId: a.id,
              sort: 0,
              score: a.score,
            };
          });
          // 添加试卷;
          AddPaperQuestion(question).then((res2) => {
            if (res3.code == 200) {
              this.$message({
                message: "编辑试卷成功",
                type: "success",
              });

              this.$router.push("/exam/PaperLibrary");
              // this.close();
            } else {
              this.$message.error("编辑失败");
            }
          });
        });
      }
    },

    // 查询编辑的数据
    Edit() {
      let para = {
        Id: this.EditId,
      };

      SelectDetailsPaper(para).then((res) => {
        console.log(res.result);
        this.cateIdisShow = true;
        this.cateId = res.result.cateId;
        this.subjectId = res.result.subjectId;
        this.temp.pagerId = res.result.deptId;
        this.temp.parentName = res.result.deptName;
        // this.defaultCheckedKeys=[{ label: '', id: 105 }],
        this.defaultCheckedKeys = this.CheckedKeys;
        this.titleinput = res.result.title;
        this.radio1 = res.result.type;
        this.radio2 = res.result.level;
        this.value4 = res.result.status;
        this.value5 = res.result.createType;
        this.sumScoreAll = res.result.totalScore;
        let arrys = JSON.parse(res.result.rules);
        this.scoreRuleObj.radioScoreTotalItem = arrys.scoreRule.score1;
        this.scoreRuleObj.checkScoreTotalItem = arrys.scoreRule.score2;
        this.scoreRuleObj.judgeScoreTotalItem = arrys.scoreRule.score3;
        this.scoreRuleObj.gapFillingScoreTotalItem = arrys.scoreRule.score4;
        this.scoreRuleObj.essayScoreTotalItem = arrys.scoreRule.score5;

        for (let i = 0; i < arrys.autoCount.length; i++) {
          if (arrys.autoCount[i].label) {
            arrys.autoCount[i].label = arrys.autoCount[i].label;
          }
          if (arrys.autoCount[i].cateIds) {
            arrys.autoCount[i].checkIds = arrys.autoCount[i].cateIds.split(",");
            console.log(arrys.autoCount[i].cateIds);
          }
        }

        this.questDatalists = arrys.autoCount;
        this.getNumli();
      });
    },

    updateTree(checkedIds, checkedData) {
      this.temp.pagerId = checkedData.id;
      this.temp.parentName = checkedData.label;
    },
    AddSubject(val) {
      this.subjectId = val.value;
    },

    SelectCate(val) {
      this.cateId = val.value;
    },
  },

  destroyed() {
    window.localStorage.removeItem("questDatalists");
    window.localStorage.removeItem("scoreRuleObj");
  },

  created() {
    this.getPmiDicLabel();
    window.localStorage.removeItem("questDatalists");
    window.localStorage.removeItem("scoreRuleObj");
    if (this.EditIds) {
      this.EditId = this.EditIds;
    }

    if (this.EditId) {
      let rowZD = JSON.parse(localStorage.getItem("rowZD")); //跳转自动组卷编辑
      this.CheckedKeys = [{ label: rowZD.deptName, id: rowZD.deptId }];

      this.Edit();
    } else {
      this.temp.parentName = JSON.parse(this.$store.state.User.infos).deptName;
      this.temp.pagerId = JSON.parse(this.$store.state.User.infos).deptId;
      this.cateIdisShow = true;
    }
  },
  watch: {
    EditId(a, b) {
      this.Edit();
    },
    subjectId(a, b) {
      this.status = true;
    },
    deep: true,
    immediate: true,
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #eff3f7;
  padding: 10px;
}
.containerst {
  overflow: auto;
  background-color: white;
}
.headbtn {
  text-align: center;
  margin-top: 20px;
}
.hr1 {
  height: 2px;
  background: #2e9eea;
}
.title1 {
  margin-top: 5px;
  font-size: 13px;
  color: #2e9eea;
}
.paperInformation {
  border: 1px dashed #e5e5e5;
  border-radius: 5px;
  padding: 10px 0 10px 30px;
}
.zhuti {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  overflow-y: auto;
}
.leftdiv {
  width: 210px;
  border-bottom: 1px solid rgb(226, 223, 223);
  margin-left: 20px;
}
.titles {
  height: 55px;
  padding-top: 15px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
li {
  padding-left: 40px;
  list-style: none;
  padding-bottom: 10px;
}
.sss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-left: 70px;
  margin-right: 20px;
  align-items: center;
}
.hhh {
  border: 1px solid rgb(226, 223, 223);

  width: calc(100% - 20px);
  margin: 0 10px 20px 10px;
}
.btfs {
  margin-left: 80px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.aaa {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  border-radius: 2px;
  background-color: #1a8cfe;
}
.leftPreview {
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  padding: 10px;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  overflow-y: auto;
}
.details-box {
  display: flex;
}
.all-scope {
  margin-right: 10px;
}
.allscore-box {
  display: flex;
  margin-top: 10px;
  align-items: center;
}
.allscore-title {
  font-size: 15px;
  font-weight: 700;
  padding-bottom: 10px;
}
.title2 {
  font-weight: bold;
  height: 40px;
  padding-top: 15px;
  padding-left: 20px;
  font-size: 18px;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
.nr {
  font-size: 14px;
  border-bottom: 1px solid rgb(226, 223, 223);
  padding: 5px 5px 10px 15px;
  margin-top: 10px;
}
.top {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  background-color: gray;
  border-radius: 2px;
}
.bottom {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-bottom: 5px;
  background-color: #f1f3f8;
  border-radius: 2px;
  margin-right: 15px;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.table {
  margin-top: 20px;
  width: 100%;
}
.nav-con {
  width: 100%;
  /* height: 350px; */
  border: 1px solid #f1f3f8;
  border-radius: 5px;
  margin-top: 20px;
}
.nav-con-child {
  color: #b2b8bd;
  margin-left: 45%;
  margin-top: 100px;
}
.leftimg {
  margin-left: 80px;
  margin-top: 200px;
}
.subject {
  display: flex;
  align-items: baseline;
}
::v-deep .vue-treeselect__control {
  width: 215px;
}
::v-deep .vue-treeselect__menu-container {
  width: 215px;
}
.title-num {
  color: #2e9eea;
  padding: 0 5px;
}
.title-box-sdjj {
  display: flex;
  justify-content: space-between;
}

.addtestQuestionsBox {
  height: 160px;
  width: calc(100% - 20px);
  margin: 20px 10px;
  border: 1px solid #dedede;
  border-radius: 4px;
  text-align: center;
  line-height: 160px;
  position: relative;
}

.addtestQuestionsBtn {
  height: 100px;
  width: 300px;
  line-height: 10px;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  position: absolute;
  top: 50px;
  right: 0;
  left: 0;
  margin: auto;
}
.q_type_btn {
  width: 82px;
  height: 34px;
  padding: 0;
  background: rgba(26, 140, 254, 0.05);
  border: 1px solid rgba(26, 140, 254, 0.2);
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1a8cfe;
  margin: 5px;
}
.addtestQuestions {
  height: 100px;
  width: 100px;
  line-height: 10px;
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  position: absolute;
  top: 50px;
  right: 0;
  left: 0;
  margin: auto;
}
.addtestQuestionsText {
  font-size: 14px;
  margin-top: 10px;
}
.addtestQuestionsIcon {
  color: #ffffff;
  background-color: #1a8cfe;
  display: inline-block;
  border-radius: 100px;
  width: 30px;
  height: 30px;
  font-size: 26px;
  line-height: 26px;
  text-align: center;
}

.fixed-add-btn {
  position: fixed;
  top: 300px;
  right: 6%;
  cursor: pointer;
  opacity: 0.75;
}
.fixed-add-btn .circle {
  width: 82px;
  height: 82px;
  padding: 20px 0;
  border-radius: 100%;
  text-align: center;
  box-shadow: 0 2px 10px 0 rgb(26 140 254 / 70%);
  background: #1a8cfe;
  color: #fff;
  position: relative;
  z-index: 2;
}

.questionContainer {
  display: none;
  position: relative;
  top: -40px;
  left: 0;
  transition: all 0.2s;
}
.fixed-add-btn:hover .questionContainer {
  width: 82px;
  display: block;
  background: #ffffff;
  box-shadow: 0 5px 10px 0 rgb(58 62 81 / 10%);
  border-radius: 2px;
  position: relative;
  top: 0px;
  left: 0;
  transition: all 0.2s;
}

.fixed-add-btn .questionContainer .questionType_adds {
  height: 40px;
  line-height: 40px;
  width: 100%;
  text-align: center;
  background: #ffffff;
  font-size: 14px;
  color: #3a3e51;
  cursor: pointer;
}

/* ----- */
.group_simpleBox {
  padding-top: 3px;
}
.group_simpleHead {
  display: flex;
  align-items: center;
  margin: 0 10px 5px 0;
}
.group_simple {
  margin-right: 10px;
  flex: 1;
}
.group_title {
  background: #f5f7fa;
  margin: 0;
  padding: 10px 0;
}

.group_titleul {
  display: flex;
  align-items: center;
}

.group_titleul_div {
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.group_titleul .lis {
  padding: 0;
  margin: 0;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.group_titleul_li {
  display: flex;
  flex: 1;
}
.group_titleul_ligs {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

::v-deep .group_titleul_ligs .el-input {
  width: 70px;
}

::v-deep .group_titleul_ligs .el-input input {
  height: 36px;
  line-height: 36px;
}

.group_titleul_div:nth-child(3) {
  border: 0;
}

.diff_div {
  font-family: PingFangSC-Regular;
  font-size: 14px;
}
.layout {
  display: flex;
  .tree {
    width: 250px;
    height: 350px;
    overflow: scroll;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    margin-right: 50px;
    padding: 10px 30px;
  }

  .row {
    display: flex;
    margin-bottom: 20px;
    align-items: center;
  }
}

.flset {
  overflow: hidden;
  text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
ul {
  padding: 0;
  margin: 0;
}

::v-deep .tagSelectSty input {
  height: 36px;
}
</style>